import { InspectionProgressPage } from '@/pages/inspection/progress/InspectionProgressPage';
import { createFileRoute } from '@tanstack/react-router';

function ProgressRoute() {
	const { inspectionId } = Route.useParams();
	return <InspectionProgressPage inspectionId={inspectionId} />;
}

export const Route = createFileRoute('/_authenticated/_app/inspection/inspections/$inspectionId/progress')({
	component: ProgressRoute,
});
